import { Box, Typography } from '@mui/material';
import React from 'react';
import { BarChart as RechartsBarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const BarChart = ({ data, dataKey, fill, width = '100%', height = 300, margin = { top: 5, right: 30, left: 20, bottom: 5 } }) => (
  <Box border="2px solid #023047" borderRadius="30px"  width="450px" height="300px" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <Box display="flex" flexDirection="row" alignItems="center">
      <Typography fontSize="16px" fontWeight="600" sx={{ writingMode: "vertical-rl", textOrientation: "sideways", color: '#023047', transform: "rotate(180deg)"}}>
        Amount
      </Typography>

      <RechartsBarChart data={data} margin={margin}  width={400} height={250}>    
        <XAxis 
          dataKey="name"         
          tickLine={false}
          axisLine={false}
          tick={{ fill: "#023047" }}
          
        />
        <Tooltip />
        {/* <Legend /> */}
        <Bar dataKey={dataKey} fill={fill} radius={16} barSize={28}/>
      </RechartsBarChart>
    </Box>

    <Box display="flex">
      <Typography fontSize="20px" fontWeight="500px">Expenses</Typography>
    </Box>
  </Box> 
);

export default BarChart;
